export function formatUserEntityRef(ref: string): string {
  if (!ref || ref === 'anonymous') return 'Anonimo';
  const name = ref.includes('/') ? ref.split('/').pop()! : ref;
  return name
    .split('.')
    .map(part => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

export interface EntityForDisplayName {
  metadata?: {
    title?: string;
    name?: string;
  };
  spec?: {
    profile?: {
      displayName?: string;
    };
  };
}

export function getCatalogEntityDisplayName(
  entity?: EntityForDisplayName | null,
): string | undefined {
  const displayName = entity?.spec?.profile?.displayName?.trim();
  if (displayName) {
    return displayName;
  }

  const title = entity?.metadata?.title?.trim();
  if (title) {
    return title;
  }

  const name = entity?.metadata?.name?.trim();
  if (name) {
    return name;
  }

  return undefined;
}
